export * from './replace.directive';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/directives/replace/index.ts